import { FormattedMessage } from 'react-intl'
import { Link } from '@src/components/Link'
import { staticContent } from '@src/routes'
import { useUserSession } from '@utils/useUserSession'
import { useCheckMMUserCountry } from '@utils/useCheckUserCountry'
import countriesMap from '@localization/countries.json'

const NonGuestShoppingMessage = () => {
  const { userSession } = useUserSession()
  const isJapanMMUser = useCheckMMUserCountry(countriesMap.JP.countryCode)
  const isIndiaMMUser = useCheckMMUserCountry(countriesMap.IN.countryCode)

  const contactLink = (
    <Link
      {...staticContent.index({
        path: isJapanMMUser
          ? '/life-science/ecommerce/ecommerce-faq/ordering-delivery-price'
          : '/collections/offices',
        language: userSession.language,
        country: userSession.country,
      })}
      passHref
    >
      <a rel="noopener" target="_blank">
        <FormattedMessage id="CONTACT" defaultMessage="contact" />
      </a>
    </Link>
  )

  if (isIndiaMMUser) {
    return (
      <FormattedMessage
        id="CONTACT_CS_FOR_ASSISTANCE"
        defaultMessage="Kindly {contactLink} customer service for assistance."
        values={{
          contactLink: contactLink,
        }}
      />
    )
  }

  return (
    <FormattedMessage
      id="CONTACT_LOCAL_DEALER"
      defaultMessage="To order products, please {contactLink} your local dealer."
      values={{
        contactLink: contactLink,
      }}
    />
  )
}

export default NonGuestShoppingMessage
